import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { OrdersParserService } from 'src/app/core/services/orders-parser';
import * as Orders from './models';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  standalone: false,
})
export class OrdersComponent implements OnInit, OnDestroy {
  /** True while the table "View more" detail is shown (hide shell Orders header + view toggle). */
  @Output() tableViewDetailActive = new EventEmitter<boolean>();

  public orders: Orders.Order[] = [];

  public selectedOrder: Orders.Order = null;

  public otherSiteServices: Orders.Order[] = [];

  public loading: boolean = true;

  public noOrders: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private service: OrdersParserService,
  ) {}

  ngOnInit() {
    this.loadOrders();
  }

  ngOnDestroy() {
    this.loading = true;
    this.tableViewDetailActive.emit(false);
  }

  private checkOrderId(): void {
    const orderId = this.route.snapshot.paramMap.get('orderId');
    if (!orderId) return;
    const filteredOrder = this.orders.filter((order) => order.id == orderId);
    if (filteredOrder.length > 0) {
      this.selectedOrder = filteredOrder[0];
      this.otherSiteServices = this.getOtherSiteServices(this.selectedOrder);
    }
  }

  private loadOrders(): void {
    // False below is to denote that we are not calling getOrders from the orders-table page
    this.service.getOrders(false)?.subscribe((orders) => {
      if (!orders) {
        this.noOrders = true;
      } else if (orders.length == 0) {
        this.noOrders = true;
      }
      this.orders = orders;
      this.checkOrderId();
      this.loading = false;
      this.tableViewDetailActive.emit(!!this.selectedOrder);
      this.ref.detectChanges();
    });
  }

  public open(order): void {
    this.tableViewDetailActive.emit(true);
    this.selectedOrder = order;
    this.otherSiteServices = this.getOtherSiteServices(order);
    this.loading = true;
    window.setTimeout(() => {
      this.loading = false;
      this.ref.detectChanges();
    }, 100);
  }

  public getOtherSiteServices(order: Orders.Order) {
    return this.orders.filter((o: Orders.Order) => o.address == order.address);
  }

  public goBack() {
    this.loading = true;
    window.setTimeout(() => {
      this.selectedOrder = null;
      this.otherSiteServices = [];
      this.loading = false;
      this.tableViewDetailActive.emit(false);
      this.ref.detectChanges();
    }, 100);
  }
}
